module.exports = {
  Days: '天',
  Weeks: '周',
  Months: '月',
  CurrentlySelected: '(当前选择)',
  CurrentPage: '(当前页)',
  NonTicketSettlement: '非票结',
  TicketSettlement: '票结',
  MonthlySettlement: '月结',
  WeeklySettlement: '周结',
  Monthly: '每月',
  Day: '日',
  CreditControl: '信用控制',
  All: '全部',
  PleaseSelectAPartner: '请选择合作伙伴.',
  InvoiceDate: '发票日期',
  BusinessDate: '业务日期',
  BillingDate: '账单日期',
  CostFinancialDate: '费用财务日期',
  System: '系统',
  PleaseASpecialApprovalBusiness: '请选择特批的业务',
  SpecialApprovalSuccessful: '特批成功',
  CancelledSpecialApprovalSuccessful: '取消特批成功',
  OceanShipping: '海运',
  PleaseFillInTheContact: '请填写联系人！',
  Other: '其他',
  CustomerType: '客户类型',
  CustomerContactChannel: '客户接触渠道',
  DueBePrintedOrNeeded: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  DearCustomersAssociatedWith: '亲，只能选择销售所关联的客户(⊙o⊙)哦',
  CharacterTooLongPleaseAgain: '字符长度超长，请重新维护！',
  ShippingTypeCannotBeEmpty: '运输类型不能为空',
  FullhalfJourneyCannotBeEmpty: '全程/半程不能为空',
  RouteCannotBeEmpty: '航线不能为空',
  PleaseAPieceOfData: '请选择一条数据！',
  OverdueFees: '超期费用',
  OverControllAccountReceivable: '超信控结算对象（应收）',
  Family: '家',
  CRMExpiredTip: '尊敬的用户，您购买的CRM模块已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">CRM模块将被限制访问，数据将被保留。等续费后，可再次使用。</div>',
  Barge: '驳船',
  SalesInquiryListPage: '销售查询列表页',
  RemoteBookingListPage: '远程订舱列表页'
}
